"use client";

import { motion } from "framer-motion";

import { screenVariants } from "./screen-variants";

interface IntroScreenProps {
  onStart: () => void;
}

export function IntroScreen({ onStart }: IntroScreenProps) {
  return (
    <motion.div
      key="intro"
      variants={screenVariants}
      initial="enter"
      animate="center"
      exit="exit"
      className="flex flex-col gap-5"
    >
      <p className="text-label-10 lg:text-label-12 pb-3 text-white opacity-40">
        Financing quiz
      </p>

      <div className="border-t border-white/10 pt-5">
        <h2 className="text-heading-24 lg:text-heading-32 text-white">
          Do you need an unsecured business loan?
        </h2>
        <p className="text-body mt-3 text-white/80">
          Answer 3 questions and we'll point you to the financing structure most
          likely to fit your business.
        </p>
        <p className="text-body-sm mt-2 text-white/60">
          Takes about 30 seconds.
        </p>
      </div>

      <button
        type="button"
        onClick={onStart}
        className="bg-pulse-700 focus-visible:ring-pulse-500 relative mt-4 inline-flex h-14 w-full items-center justify-center overflow-hidden rounded-[14px] px-6 text-base font-semibold text-white transition-colors after:absolute after:inset-0 after:block after:h-full after:w-full after:rounded-[14px] after:transition-colors hover:after:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-black lg:w-auto lg:self-start"
      >
        {/* TODO: track event quiz_started */}
        Start
      </button>
    </motion.div>
  );
}
